<template>
  <div
    class="list-view"
    @touchmove="dropMove"
    @touchstart="dropStart"
    @touchend="dropEnd"
  >
    <div
      :class="{'animation': needAnimation}"
      :style="{transform: transformValue}"
    >
      <div
        class="list-top"
        :style="{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: -50,
          width: '100%',
          height:50,
        }"
      >
        <hy-text>{{ refreshText }}</hy-text>
      </div>
      <ul
        class="list-contain"
        @scroll="onScroll"
      >
        <slot />
        <li
          :style="{display: 'flex', alignItems: 'center', justifyContent: 'center', height: 50,}"
          @click="onLoadTextClick"
        >
          <p
            v-if="showLoadMore"
            :style="{color: '#999999', fontSize: 12,}"
          >
            {{ getLoadText }}
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import CONST from './const';

// 获得角度
function getAngle(angx, angy) {
  return Math.atan2(angy, angx) * 180 / Math.PI;
}

function getDirection(startx, starty, endx, endy) {
  const angx = endx - startx;
  const angy = endy - starty;
  let result = 0;

  // 如果滑动距离太短
  if (Math.abs(angx) < 2 && Math.abs(angy) < 2) {
    return result;
  }

  const angle = getAngle(angx, angy);
  if (angle >= -135 && angle <= -45) {
    result = 1;
  } else if (angle > 45 && angle < 135) {
    result = 2;
  } else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
    result = 3;
  } else if (angle >= -45 && angle <= 45) {
    result = 4;
  }

  return result;
}

export default {
  name: 'HyList',
  props: {
    dropUpdate: {
      type: Boolean,
      default: true,
    },
    dropMore: {
      type: Boolean,
      default: true,
    },
    // 是否需要显示the end文案
    showLoadMore: {
      type: Boolean,
      default: true,
    },
    // scrollView: {
    //  type: Object,
    //  default: null
    // },
    loadmore: {
      type: Function,
      default: () => {},
    },
    refresh: {
      type: Function,
      default: () => {},
    },
    // 是否已经结束，外部传入
    isEnd: {
      type: Boolean,
      default: false,
    },
    // 是否加载错误，此处只适用于下拉刷新，点击会重新调用refresh
    isRefreshError: {
      type: Boolean,
      default: false,
    },
    // 是否加载错误，此处只适用于上拉加载，点击会重新调用loadmore，如果有pageIndex的使用要注意不要一直叠加
    isError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      transformValue: '',
      needAnimation: false,
      dropDownStyle: {
        height: 0,
      },
      startY: 0,
      endY: 0,
      offset: 0,
      maxHeight: 3000,
      isTop: true,
      isBottom: false,
      loadingText: '',
      refreshText: CONST.REFRESH_TEXT,
      platform: Vue.Native.Platform === 'browser',
      listBottomTextStyle: {
      },
      // 0 未触发下拉刷新 1 触发下拉刷新
      isRefresh: false,
      // 是否刷新完成
      isRefreshFinished: false,
      // 没在加载 true 在加载
      isLoading: false,
      // 0 未加载 1 加载结束
      isLoad: false,
      // 是否结束 兼容过去写法 这种end并不准确 必须要通过下一次滑动判断
      isEndNext: false,
    };
  },
  computed: {
    getLoadText() {
      if (this.isInitializing) { // 正在初始化
        return '正在加载中';
      } if (this.isLoading) { // 加载中
        // 确认是否是上拉加载
        if (this.isLoad) {
          return '正在加载中...';
        } if (this.isRefresh) {
          // 下拉加载
          return '';
        }
        // 手动加载
        return '正在加载中...';
      } if (this.isRefreshError || this.isError) {
        return '加载失败，点击重试';
      }
      // 已经触底
      if (this.isEnd || this.isEndNext) {
        if (this.numberOfRows > 0) {
          return '- THE END -';
        }
      } else {
        // 尚未触底
        if (this.isInit) {
          return '正在加载中...';
        }
      }
      return '';
    },
  },
  mounted() {
    this.scrollV = this.scrollView || window;
    this.scrollV && this.scrollV.addEventListener('scroll', this.scroll, true);
  },
  destroyed() {
    this.scrollV && this.scrollV.removeEventListener('scroll', this.scroll);
  },
  methods: {
    dropStart(event) {
      const touch = event.touches[0];
      this.startX = touch.clientX;
      this.startY = touch.clientY;
    },
    async dropMove(event) {
      const touch = event.touches[0];
      this.endX = touch.clientX;
      this.endY = touch.clientY;
      const direction = getDirection(this.startX, this.startY, this.endX, this.endY);
      if ([3, 4, 0].indexOf(direction)) {
        event.stopPropagation();
      }
      this.offset = this.endY - this.startY;
      console.log('this.endY', touch.clientY);
      console.log('this.isTop', this.isTop);
      console.log('this.isBottom', this.isBottom);
      console.log('this.offset', this.offset);
      this.needAnimation = false;
      // 下拉刷新
      if (this.isTop && this.offset > 0) {
        if (this.offset < 50) {
          this.refreshText = CONST.REFRESH_DROP_TEXT;
          this.transformValue = `translate3d(0, ${this.offset}px, 0)`;
        } else {
          this.refreshText = CONST.REFRESH_ENTER_TEXT;
          this.transformValue = 'translate3d(0, 50px, 0)';
        }
      } else if (this.isBottom && this.offset < 0) {
        // 上拉加载不用控制
      }
    },
    async dropEnd() {
      console.log('this.isBottom', this.isBottom);
      console.log('this.offset', this.offset);

      if (this.isTop && (this.offset > 50)) {
        this.refreshText = CONST.REFRESH_LOADING_TEXT;
        await this.refresh();
        // await new Promise((resolve, reject) => {
        //   setTimeout(() => {
        //     resolve();
        //   }, 1000);
        // });
        this.refreshText = CONST.REFRESH_FINISHED_TEXT;
        this.loadingText = '';
        this.$emit('refresh');
        this.needAnimation = true;
        this.transformValue = 'translate3d(0, 0, 0)';
        this.dropDownStyle.height = 0;
      } else if (this.isBottom && this.offset <= 0) {
        // 上拉不处理
      }
    },
    async onRefresh() {
      if (this.isLoading || this.isLoad || this.isInitializing) {
        // 2.0 改版方法
        this.$refs.refreshWrapper.refreshCompleted();
        // Vue.Native.callUIFunction(this.$refs.refreshWrapper, 'refreshComplected', null);
        return false;
      }
      this.isEndNext = false;
      // 上面是重置逻辑
      this.isLoading = true;
      this.isRefresh = true;
      const newData = await this.refresh();
      this.isLoading = false;
      this.isRefresh = false;
      this.isRefreshFinished = true;
      setTimeout(() => {
        // 2.0 改版方法
        this.$refs.refreshWrapper.refreshCompleted();
        // Vue.Native.callUIFunction(this.$refs.refreshWrapper, 'refreshComplected', null);
        this.isEndNext = Array.isArray(newData) && newData.length === 0;
        this.$emit('refresh');
        setTimeout(() => {
          this.isRefreshFinished = false;
        }, 200);
      }, 300);
    },
    async onEndReached() {
      if (this.isRefreshError
          || this.isLoading
          || this.isLoad
          || this.isEnd
          || this.isInitializing
          || !this.loadmore
          || this.isEndNext
      ) return false;
      this.isLoading = true;
      this.isLoad = true;
      const newData = await this.loadmore();
      this.isLoading = false;
      this.isLoad = false;
      this.isEndNext = !newData || newData.length === 0;
      this.$emit('loadmore');
    },
    scroll(event) {
      const target = event.target === document ? document.documentElement : event.target;
      // console.log(target);
      if (target.scrollTop === 0) {
        this.isTop = true;
      } else if (target.scrollHeight === (target.scrollTop + target.clientHeight)) {
        this.isBottom = true;
        this.onEndReached();
      } else {
        this.isTop = false;
        this.isBottom = false;
      }
    },
    onScroll(e) {
      e.preventDefault();
    },
    onLoadTextClick() {
      // if (this.isRefreshError) {
      //   this.initList();
      // } else if (this.isError) {
      //   this.onEndReached();
      // }
    },
  },
};
</script>

<style scoped>
.animation {
  transition: transform 0.3s ease-in-out;
}

.list-view {
  position: relative;
  height: 100%;
  overflow: hidden;
}
.list-top {
 overflow: hidden;
 text-align: center;
}
.list-contain {
  height: 100%;
  overflow-y: scroll;
}
</style>
